import HomeStartUpAbout from "components/abouts/home-stratup-about";
import StartUpFaqs from "components/faqs/start-up-faqs";
import HomeStartupBanner from "components/hero-banners/home-startup-banner";
import SEO from "components/seo";
import StartUpSupport from "components/supports/start-up-support";
import ServicesVision from "components/visions/services-vision";
import FooterSeven from "layout/footers/footer-7";
import HeaderSix from "layout/headers/header-6";
import Wrapper from "layout/wrapper";
import React from "react";
import { Link } from "react-router-dom";
import CustomPortfolio from "./custom-portfolio";
import AgencyCta from "components/cta/agency-cta";
import AboutFaqs from "components/abouts/about-page-com/about/about-faqs";
import HomePortFolio from "data/home-portfolio";
import HomePopup from "components/common/home-popup";
import HomeTrustedBrands from "components/brands/home-trusted-brands";

const Anouncement = () => {
  return (
    <div className="container">
      <div className="row justify-content-center mb-2">
        <div className="col-xxl-10 col-xl-10 col-lg-11">
          <div
            className="features__offer text-center mt-20 wow fadeInUp"
            data-wow-delay=".9s"
            data-wow-duration="1s"
          >
            <span>LIVE NOW</span>
            <p>
              {" "}
              {/* If you want to join the effort and help with the plugin, please{" "} */}
              Experience Ghar360's Interactive Property Walkthrough Demo on the
              <Link to="https://play.google.com/store/apps/details?id=com.rionick.ghar360">
                {" "}
                Google Play Store
              </Link>
              {/* from our upcoming modeling and animation library. */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomeStartUp = () => {
  return (
    <>
      <Wrapper>
        <SEO
          metaTitle={"Rionick Studios | 3D, CGI, AR & Interactive Digital Experiences"}
          metaDesc={
            "Rionick Studios creates 3D modeling and animation, viral CGI videos, AR experiences, games, graphic design and digital marketing, and builds Ghar360 and ARRISE."
          }
          metaKeywords={
            "Rionick Studios, 3d modeling services, 3d animation, cgi videos, ar experiences, Ghar360, ARRISE, game development services, graphic design, digital marketing services"
          }
          canonical="https://www.rionick.com/"
          pageTitle={"Rionick Studio | Home"}
        />
        <div className="rionick-home">
        <HeaderSix />
        <HomePopup />
        <HomeStartupBanner />
        <HomeTrustedBrands />
        {/* <StartupFeatures /> */}
        <HomeStartUpAbout />
        <Anouncement />
        <ServicesVision />
        <AgencyCta
          content="LET’S TALK ABOUT YOUR NEXT PROJECT"
          title="Looking for customized 3D Models at scale?"
          btext="Get In Touch"
          bclr="tp-btnr bg-danger tp-btn-shine-effect"
          element_style={true}
        />
        <AboutFaqs
          element_style={true}
          head={"Built for Modern Real Estate Sales"}
          title={"Sell your Apartment Before You Build with Ghar360"}
          desc={
            "Step inside your future property before it's even built. Ghar360 transforms architectural plans into immersive real-time experiences, allowing buyers to explore every room, compare furnished and unfurnished interiors, visualize actual balcony views, and interact with the property just as they would in real life. Designed for builders and sales teams, it helps buyers make faster, more confident purchasing decisions."
          }
          cta={{ label: "Explore Ghar360", to: "/ghar360" }}
        />
        <CustomPortfolio data={HomePortFolio} />
        <StartUpSupport />
        <StartUpFaqs />
        <FooterSeven />
        </div>
      </Wrapper>
    </>
  );
};

export default HomeStartUp;
